/* GTJ speed + slow-network loading UX (round 25).
   1. Speculation Rules: Chromium prerenders product pages (and prefetches
      collection pages) the moment the user shows intent (hover / touch,
      "moderate" eagerness) - taps then feel instant. Safari/Firefox: no-op.
   2. Navigation progress bar: thin black bar at the very top that starts
      trickling when an internal link is tapped and completes as the next
      page takes over. On a slow network the user sees motion instead of a
      frozen page - the "please wait" affordance.
   3. Image-wait placeholders: while a product/card image is still
      downloading its box pulses soft grey (class gtj-img-wait, styled in
      gtj-card-extras.css) instead of sitting as a white hole / broken
      glyph. */
(function () {
  /* ---- 1. speculative loading - ALL browsers (round 28) ----
     Tier 1 (Chromium desktop/Android): Speculation Rules full prerender.
     Tier 2 (everything else - iOS Safari, macOS Safari, Firefox): on the
     first touch/hover of a product or collection link, prefetch the page
     HTML into the HTTP cache (<link rel=prefetch> where supported,
     fetch() fallback for Safari) - the tap then starts with the document
     already local. Respects Data Saver / 2G. */
  var specOK = false;
  try {
    if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      specOK = true;
      var sr = document.createElement('script');
      sr.type = 'speculationrules';
      sr.textContent = JSON.stringify({
        prerender: [{ where: { href_matches: '/products/*' }, eagerness: 'moderate' }],
        prefetch: [{ where: { href_matches: '/collections/*' }, eagerness: 'moderate' }]
      });
      document.head.appendChild(sr);
    }
  } catch (e) { /* older engines: never block the page over this */ }
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  var frugal = !!(conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '')));
  var linkPrefetchOK = false;
  try {
    var probe = document.createElement('link');
    linkPrefetchOK = !!(probe.relList && probe.relList.supports && probe.relList.supports('prefetch'));
  } catch (e2) {}
  var warmed = {};
  var warm = function (href) {
    if (frugal || warmed[href]) return;
    warmed[href] = 1;
    try {
      if (linkPrefetchOK) {
        var l = document.createElement('link');
        l.rel = 'prefetch';
        l.as = 'document';
        l.href = href;
        document.head.appendChild(l);
      } else if (window.fetch) {
        /* Safari: no rel=prefetch - a plain same-origin fetch warms the
           HTTP cache (when cacheable) and, always, the TLS connection +
           Shopify edge cache for the real navigation */
        fetch(href, { credentials: 'same-origin' }).catch(function () {});
      }
    } catch (e3) {}
  };
  /* ---- 1b. FIRST-navigation idle warmup (5Aug, user: "when i first
     open a different page it shows this loading sign"): intent-based
     warming only fires ms before the tap - the FIRST navigation to
     another template was still cold (HTML + that template's CSS). After
     load, once the thread is idle, warm the most likely next pages
     (first collection/product links in the document = menu + first
     cards) on EVERY engine - iOS/Android/desktop alike. Data Saver and
     2G are respected via the same frugal flag.
     1Sep perf round: trimmed 6 -> 3 warmed pages and start 1.5s -> 3s
     after load - six full-document prefetches (~110KB each at the time)
     were measured competing with the page's own late images on slow
     networks, which is exactly the window where the broken-image
     glyphs appeared. */
  var idleWarm = function () {
    if (frugal) return;
    var links = document.querySelectorAll('a[href*="/collections/"], a[href*="/products/"]');
    var picked = 0;
    for (var i = 0; i < links.length && picked < 3; i++) {
      try {
        var u = new URL(links[i].href, location.href);
        if (u.origin !== location.origin) continue;
        var key = u.pathname + u.search;
        if (warmed[key]) continue;
        warm(key);
        picked++;
      } catch (e5) {}
    }
  };
  var scheduleIdleWarm = function () {
    setTimeout(function () {
      if (window.requestIdleCallback) requestIdleCallback(idleWarm, { timeout: 4000 });
      else setTimeout(idleWarm, 1000);
    }, 3000);
  };
  if (document.readyState === 'complete') scheduleIdleWarm();
  else window.addEventListener('load', scheduleIdleWarm);
  if (!specOK) {
    var intent = function (e) {
      var t = e.target;
      var a = t && t.closest ? t.closest('a[href*="/products/"], a[href*="/collections/"]') : null;
      if (!a) return;
      try {
        var u = new URL(a.href, location.href);
        if (u.origin !== location.origin) return;
        warm(u.pathname + u.search);
      } catch (e4) {}
    };
    document.addEventListener('touchstart', intent, { passive: true, capture: true });
    document.addEventListener('mouseover', intent, { passive: true, capture: true });
  }

  /* ---- 2. navigation progress bar ---- */
  var bar = null;
  var hideTimer = null;
  var pendingBar = null;
  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.setAttribute('aria-hidden', 'true');
    bar.style.cssText =
      'position:fixed;top:0;left:0;height:2px;width:0;background:#000;' +
      'z-index:2147483000;opacity:0;pointer-events:none;' +
      'transition:width 8s cubic-bezier(.08,.74,.14,1),opacity .2s ease';
    document.documentElement.appendChild(bar);
    return bar;
  }
  function startBar() {
    var b = ensureBar();
    clearTimeout(hideTimer);
    b.style.transition = 'none';
    b.style.width = '0';
    b.style.opacity = '1';
    void b.offsetWidth; /* commit the reset before animating */
    b.style.transition = 'width 8s cubic-bezier(.08,.74,.14,1),opacity .2s ease';
    b.style.width = '82%';
  }
  function finishBar() {
    if (!bar) return;
    bar.style.transition = 'width .25s ease,opacity .3s ease .25s';
    bar.style.width = '100%';
    bar.style.opacity = '0';
    hideTimer = setTimeout(function () { if (bar) { bar.style.transition = 'none'; bar.style.width = '0'; } }, 650);
  }
  /* capture phase so drawer links (whose own capture handlers call
     stopPropagation - gotcha 17) still reach us; the defaultPrevented
     re-check runs 100ms later, after every other handler has decided
     whether this click actually navigates */
  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download')) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    if (u.pathname === location.pathname && u.search === location.search && u.hash) return;
    /* 5Aug (user: the bar itself read as a "loading sign" on ordinary
       navigations): only show it when the navigation is actually SLOW.
       The 100ms defaultPrevented re-check stays; the bar then waits
       another 350ms - if the next page takes over before ~450ms total
       (warm cache, prerender), pagehide cancels it and nothing ever
       appears. Slow loads still get the please-wait affordance. */
    setTimeout(function () {
      if (e.defaultPrevented) return;
      clearTimeout(pendingBar);
      pendingBar = setTimeout(startBar, 350);
    }, 100);
  }, true);
  window.addEventListener('pagehide', function () {
    clearTimeout(pendingBar);
    finishBar();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { clearTimeout(pendingBar); finishBar(); } });

  /* ---- 3. image-wait placeholders ---- */
  function markWaiting() {
    var imgs = document.querySelectorAll(
      '.card__media img, .product__media-item .media img, .gtj-recent__media img, .gtj-search-rec__media img'
    );
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        if (img.__gtjWaitWired) return;
        img.__gtjWaitWired = true;
        if (img.complete) return;
        var box = img.closest('.media') || img.parentElement;
        if (!box) return;
        box.classList.add('gtj-img-wait');
        function done() { box.classList.remove('gtj-img-wait'); }
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      })(imgs[i]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markWaiting);
  } else {
    markWaiting();
  }
  window.addEventListener('load', markWaiting);

  /* ---- 4. back-navigation scroll memory (round 44) ----
     User: tapping a product from a scrolled collection and coming BACK
     landed at the top instead of at the tapped product. When Safari
     serves the return from bfcache it restores scroll natively - this
     covers the FULL-RELOAD returns: the scroll position is saved per
     page at the moment a product link is tapped and re-applied on a
     back/forward load, retrying while late content (lazy images,
     view-more items) grows the page. Clamped to the document height,
     so a shorter re-served page degrades to "as far down as exists". */
  try {
    var SKEY = 'gtjscroll:' + location.pathname + location.search;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (!a) return;
      try { sessionStorage.setItem(SKEY, String(Math.round(window.scrollY || 0))); } catch (err) {}
    }, true);
    var navType = '';
    try {
      var navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
      navType = navEntries && navEntries[0] ? navEntries[0].type : '';
    } catch (err) {}
    if (navType === 'back_forward') {
      var savedY = 0;
      try { savedY = parseInt(sessionStorage.getItem(SKEY) || '0', 10) || 0; } catch (err) {}
      if (savedY > 0) {
        var tries = 0;
        var restore = function () {
          tries++;
          var maxY = Math.max(0, (document.documentElement.scrollHeight || 0) - window.innerHeight);
          window.scrollTo(0, Math.min(savedY, maxY));
          if (tries < 8 && Math.abs((window.scrollY || 0) - savedY) > 40) setTimeout(restore, 250);
        };
        if (document.readyState === 'complete') restore();
        else window.addEventListener('load', restore);
      }
    }
  } catch (e) { /* never break the page over scroll restoration */ }
})();
